import React from "react";
import PropTypes from "prop-types";

import Alert from 'react-bootstrap/Alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        // Actualiza el estado para mostrar el UI alternativo
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        console.error("Error capturado por ErrorBoundary:", error, info);
    }

    render() {
        if (this.state.hasError) {
            // Fallback: puedes personalizarlo
            return this.props.fallback ||
                <>

                <Alert key={"danger"} variant={"danger"} className="m-1">
                        <strong>
                   
                            <FontAwesomeIcon
                                icon="triangle-exclamation"
                                className="text-danger me-2"
                            />
                            {/*<span>Algo salio mal en este modulo</span>*/}
                    
                        {
                            this.state.error?.message || "Algo salió mal en este componente."
                        }
                        {
                            this.props.fallback &&
                            (
                                <div className="mt-2">{this.props.fallback}</div>
                            )
                        }

                        </strong>{" "}
                    </Alert>
                   
                </>
            
            //<h3>Ocurrió un error en este módulo</h3>;
        }
        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    fallback: PropTypes.node,  // Puede ser cualquier cosa que se pueda renderizar
    children: PropTypes.node.isRequired,
};

export default ErrorBoundary;
